import { ChartOptions } from 'chart.js';

export const getRadarOptions = (isMobile: boolean): ChartOptions<'radar'> => {
  return {
    elements: {
      line: {
        borderWidth: 3,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    aspectRatio: 1.5,
    layout: {
      padding: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      },
    },
    plugins: {
      title: {
        display: false,
      },
      legend: {
        align: 'center',
        position: 'top',
        labels: {
          pointStyle: 'circle',
          usePointStyle: true,
          padding: 10,
        },
      },
    },
    scales: {
      r: {
        min: 0,
        max: 10,
        pointLabels: {
          font: {
            size: isMobile ? 10 : 14,
          },
          padding: 0,
        },
        ticks: {
          font: {
            size: isMobile ? 9 : 12,
            weight: 'bold',
          },
          color: 'black',
          showLabelBackdrop: true,
        },
      },
    },
    interaction: {
      mode: 'index' as const,
    },
  };
};
